export const trim = (value) => {
	return typeof value === 'string' ? value.trim() : value;
};
